import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./BusinessCard.css";

gsap.registerPlugin(ScrollTrigger);

function BusinessCard({ 
  name = "박대성",
  team = "테크팀", 
  phone = "010-6533-1985",
  email = "pds@alipeople.kr",
  showLogo = true,
  logoSrc = "/assets/logos/aligo_alternate_positive.png",
  logoAlt = "ALIGO",
  logoFadeOut = false,
  className = "",
  variant = "default", // default, compact, full
  enableScrollAnimation = false, // 스크롤 애니메이션 활성화 여부
  scrollTriggerConfig = {} // ScrollTrigger 설정
}) {
  const cardRef = useRef(null);
  const overlayRef = useRef(null);

  useEffect(() => {
    if (enableScrollAnimation && overlayRef.current) {
      // 초기 상태: 오버레이 투명
      gsap.set(overlayRef.current, { opacity: 0 });
      
      // 스크롤 애니메이션 설정
      gsap.to(overlayRef.current, {
        scrollTrigger: {
          trigger: cardRef.current,
          start: 'top 60%',
          end: 'top 20%',
          scrub: 1,
          markers: false,
          ...scrollTriggerConfig // 외부에서 전달받은 설정 적용
        },
        opacity: 1,
        ease: 'none', // 스크롤과 직접 연동되므로 easing 제거
      });
    }

    return () => {
      if (enableScrollAnimation) {
        ScrollTrigger.getAll().forEach(trigger => trigger.kill());
      }
    };
  }, [enableScrollAnimation, scrollTriggerConfig]);
  return (
    <div className={`business-card ${variant} ${className}`} ref={cardRef}>
      <div className="business-card-content">
        {showLogo && (
          <div className={`business-card-left ${logoFadeOut ? 'fade-out' : ''}`}>
            <img 
              src={logoSrc} 
              alt={logoAlt} 
              className="business-card-logo"
            />
          </div>
        )}
        <div className={`business-card-right ${!showLogo ? 'full-width' : ''}`}>
          <h2 className="business-card-company">알리는사람들</h2>
          <p className="business-card-subtitle">ALIPEOPLE</p>
          <div className="business-card-info">
            <p className="business-card-name">{name}</p>
            <p className="business-card-team">{team}</p>
            <p className="business-card-phone">{phone}</p>
            <p className="business-card-email">{email}</p>
          </div>
        </div>
      </div>
      {/* 명함 전체를 가리는 오버레이 - 스크롤 애니메이션 시 사용 */}
      {enableScrollAnimation && (
        <div className="business-card-overlay" ref={overlayRef} />
      )}
    </div>
  );
}

export default BusinessCard;